import { jsxs, jsx } from 'react/jsx-runtime';

const DEFAULT_STYLES = {
    pointerEvents: 'all',
    transition: 'opacity 0.25s ease',
};
const getStyles = (visibility) => {
    switch (visibility) {
        case 'hidden':
            return {
                ...DEFAULT_STYLES,
                opacity: 0,
            };
        case 'partial':
            return {
                ...DEFAULT_STYLES,
                opacity: 0.4,
            };
        default:
            return DEFAULT_STYLES;
    }
};
const DEFAULT_COLOUR = '#DB00F0';
function GroundPosition({ colour = DEFAULT_COLOUR, id, onClick, onMouseEnter, onMouseLeave, testId, visibility = 'visible', }) {
    const radialGradientId = `gradient-inverse-${id}`;
    const horseShoeMaskId = `horse-shoe-mask-${id}`;
    const horseShoeRadialGradientId = `horse-shoe-gradient-${id}`;
    const clipPathId = `clip-${id}`;
    return (jsxs("g", { id: id, "data-colour": colour, "data-testid": testId, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: getStyles(visibility), children: [jsxs("defs", { children: [jsx("clipPath", { id: clipPathId, children: jsx("rect", { x: "-1", y: "-0.5", width: "2", height: "2" }) }), jsxs("mask", { id: horseShoeMaskId, children: [jsx("rect", { x: "-1.5", y: "-1.5", width: "3", height: "3", fill: "white" }), jsx("circle", { cx: "0", cy: "-0.75", fill: `url(#${horseShoeRadialGradientId})`, r: "0.85" })] }), jsxs("radialGradient", { id: horseShoeRadialGradientId, cx: "50%", cy: "50%", r: "50%", fx: "50%", fy: "50%", children: [jsx("stop", { offset: "50%", style: { stopColor: 'black' } }), jsx("stop", { offset: "100%", style: { stopColor: 'transparent' } })] }), jsxs("radialGradient", { id: radialGradientId, cx: "50%", cy: "50%", r: "50%", fx: "50%", fy: "50%", children: [jsx("stop", { offset: "0%", style: { stopColor: 'transparent' } }), jsx("stop", { offset: "100%", style: { stopColor: colour } })] })] }), jsx("circle", { cx: "0", cy: "0", fill: `url(#${radialGradientId})`, mask: `url(#${horseShoeMaskId})`, r: 1, stroke: "black", strokeWidth: "0.02", style: {
                    cursor: 'pointer',
                } })] }));
}

export { GroundPosition, GroundPosition as default };
//# sourceMappingURL=GroundPosition.js.map
